export default __webpack_public_path__ + "static/media/scissors.d53b369c.png";